import React from 'react'
import useSnackbar from 'hooks/useSnackbar'

import {
  Button,
  Dialog,
  Divider,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Typography,
} from '@material-ui/core'

import * as service from 'service'

const DialogTaxInactive = ({
  open,
  handleClose,
  taxId,
  onEvent = () => {},
}) => {
  const snackbar = useSnackbar()

  const onSubmit = async () => {
    try {
      await service.recurrence.taxes.update({
        taxId,
        tax: { active: false },
      })

      snackbar.open({
        message: 'Imposto inativado com sucesso!',
        variant: 'success',
      })

      onEvent()
      handleClose()
    } catch {
      snackbar.open({
        message: 'Falha ao inativar imposto!',
        variant: 'error',
      })
    }
  }

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle id="form-dialog-title">
        <div>
          <Typography variant="h3">Inativar imposto</Typography>
        </div>
      </DialogTitle>
      <DialogContent>
        <DialogContentText align="justify">
          Atenção: Ao inativar este imposto ele deixará de ser cobrado em todas
          as assinaturas que o tenham vinculado.
        </DialogContentText>
      </DialogContent>
      <Divider />
      <DialogActions p={2}>
        <Button variant="contained" color="primary" onClick={onSubmit}>
          Inativar
        </Button>
        <Button onClick={handleClose} variant="outlined" color="primary">
          Cancelar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DialogTaxInactive
